import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultFields, EbaCustomField } from '@/effects/use-eba-effect/constant';

import { ActionDroplistModel } from '@/pages/service-level-agreement/components/select-action/action.model';
import { EbaAutomationModel } from '@/models/automation.model';

export type TabKeyType = 'active' | 'inactive';

export interface EbaState {
  currentTab: TabKeyType;
  isShowAddCategory: boolean;
  customFields: EbaCustomField[];
  automationList: EbaAutomationModel[];
  conditionsAlls: ActionDroplistModel[];
  conditionsAnys: ActionDroplistModel[];
  actionOptions: ActionDroplistModel[];
}

const initialState: EbaState = {
  currentTab: 'active',
  isShowAddCategory: false,
  customFields: defaultFields,
  automationList: [],
  conditionsAlls: [],
  conditionsAnys: [],
  actionOptions: [],
};

const EbaStore = createSlice({
  name: 'event-automation',
  initialState,
  reducers: {
    setCurrentTab: (state, action: PayloadAction<EbaState['currentTab']>) => {
      state.currentTab = action.payload;
    },
    setShowAddCategory: (state, action: PayloadAction<EbaState['isShowAddCategory']>) => {
      state.isShowAddCategory = action.payload;
    },
    setAutomationList: (state, action: PayloadAction<EbaState['automationList']>) => {
      state.automationList = action.payload;
    },
    setCustomFields: (state, action: PayloadAction<EbaState['customFields']>) => {
      state.customFields = action.payload;
    },
    setConditionsAlls: (state, action: PayloadAction<EbaState['conditionsAlls']>) => {
      state.conditionsAlls = action.payload;
    },
    setConditionsAnys: (state, action: PayloadAction<EbaState['conditionsAnys']>) => {
      state.conditionsAnys = action.payload;
    },
    setActionOptions: (state, action: PayloadAction<EbaState['actionOptions']>) => {
      state.actionOptions = action.payload;
    },
  },
});

export const {
  setCurrentTab,
  setShowAddCategory,
  setCustomFields,
  setAutomationList,
  setConditionsAlls,
  setConditionsAnys,
  setActionOptions,
} = EbaStore.actions;

export default EbaStore.reducer;
